"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dateToEpochSeconds_1 = __importDefault(require("../utils/dateToEpochSeconds"));
function getUpdatedSectionLastStats(aggregatedStat, sessionEvent) {
    var _a, _b;
    const { session } = sessionEvent;
    if (sessionIsOlderThanLastRecorded(aggregatedStat, sessionEvent)) {
        return {
            lastStudied: aggregatedStat.lastStudied,
            lastScore: (_a = aggregatedStat.lastScore) !== null && _a !== void 0 ? _a : 0
        };
    }
    else {
        const timeFinishedSeconds = (0, dateToEpochSeconds_1.default)(session.timeFinished);
        return {
            lastStudied: timeFinishedSeconds,
            lastScore: (_b = session.sessionScore) !== null && _b !== void 0 ? _b : 0
        };
    }
}
exports.default = getUpdatedSectionLastStats;
function sessionIsOlderThanLastRecorded(aggregatedStat, sessionEvent) {
    if (!aggregatedStat)
        return false;
    return (aggregatedStat.lastStudied >
        (0, dateToEpochSeconds_1.default)(sessionEvent.session.timeFinished));
}
